import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

// Create styles that match your website
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#F9FAFB',
    padding: 0,
    fontFamily: 'Helvetica',
  },
  container: {
    flex: 1,
    padding: 20,
  },
  // Purple summary box with shadow
  summaryBox: {
    backgroundColor: '#3399FF',
    borderRadius: 8,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#5B21B6',
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
  },
  summaryTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: 15,
  },
  summaryGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  summaryColumn: {
    flex: 1,
    marginRight: 20,
  },
  summaryItem: {
    marginBottom: 8,
    fontSize: 11,
    color: '#FFFFFF',
  },
  // Chart section
  chartSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
  chartTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#3399FF',
    marginBottom: 15,
    textAlign: 'center',
  },
  chartImage: {
    width: '100%',
    height: 300,
    marginBottom: 15,
  },
  chartPlaceholder: {
    width: '100%',
    height: 300,
    backgroundColor: '#F3F4F6',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
    border: '2px dashed #D1D5DB',
  },
  chartPlaceholderText: {
    fontSize: 14,
    color: '#6B7280',
    fontStyle: 'italic',
  },
  // Repayment info box
  repaymentBox: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: 15,
    marginBottom: 20,
    borderLeft: '4px solid #3399FF',
  },
  repaymentTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3399FF',
    marginBottom: 8,
  },
  repaymentText: {
    fontSize: 12,
    color: '#4B5563',
    marginBottom: 4,
  },
  // Footer
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: 'center',
    fontSize: 10,
    color: '#6B7280',
  },
});

const BeautifulPDF = ({ loanData, chartImage }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.container}>
        {/* Purple Summary Box */}
        <View style={styles.summaryBox}>
          <Text style={styles.summaryTitle}>
            {loanData.userName || 'Gebruiker'}'s Spaarplan
          </Text>
          <View style={styles.summaryGrid}>
            <View style={styles.summaryColumn}>
              <Text style={styles.summaryItem}>
                Totale kosten: €{loanData.totalCost.toLocaleString('nl-NL')}
              </Text>
              <Text style={styles.summaryItem}>
                Betaald aan rente: €{loanData.interestAtEnd.toLocaleString('nl-NL')}
              </Text>
              <Text style={styles.summaryItem}>
                Looptijd: {loanData.payoffYears} jaar
              </Text>
            </View>
            <View style={styles.summaryColumn}>
              <Text style={styles.summaryItem}>
                Maandbedrag: €{loanData.monthlyPayment.toLocaleString('nl-NL')}
              </Text>
              <Text style={styles.summaryItem}>
                Rentepercentage: {(loanData.annualRate * 100).toFixed(2)}%
              </Text>
              <Text style={styles.summaryItem}>
                {loanData.enableInvestment 
                  ? `Toegevoegde waarde: ${loanData.addedInvestmentValue > 0 ? '+' : ''}€${Math.round(loanData.addedInvestmentValue).toLocaleString('nl-NL')}`
                  : 'Strategie: Alleen aflossen'
                }
              </Text>
            </View>
          </View>
        </View>

        {/* Chart Section */}
        <View style={styles.chartSection}>
          <Text style={styles.chartTitle}>AFLOSSING GRAFIEK</Text>
          {chartImage ? (
            <Image style={styles.chartImage} src={chartImage} />
          ) : (
            <View style={styles.chartPlaceholder}>
              <Text style={styles.chartPlaceholderText}>
                Grafiek kon niet worden weergegeven
              </Text>
            </View>
          )}
        </View>

        {/* Repayment Information */}
        <View style={styles.repaymentBox}>
          <Text style={styles.repaymentTitle}>LENING AFBETALING</Text>
          {loanData.payoffByInvestment ? (
            <>
              <Text style={styles.repaymentText}>
                Lening afbetaald door investering op {loanData.payoffYears} jaar
              </Text>
              <Text style={styles.repaymentText}>
                Investering waarde: €{loanData.finalInvestmentValue.toLocaleString('nl-NL')}
              </Text>
            </>
          ) : (
            <>
              <Text style={styles.repaymentText}>
                Lening volledig afbetaald op {loanData.payoffYears} jaar
              </Text>
              <Text style={styles.repaymentText}>
                Restschuld: €0
              </Text>
            </>
          )}
        </View>
      </View>

      {/* Footer */}
      <Text style={styles.footer}>
        Dit rapport is gegenereerd door Slimmer af - Uw persoonlijke aflosplanner
      </Text>
    </Page>
  </Document>
);

export default BeautifulPDF;
